import axios from '../../../axios/index.js'
// import store from '../../../../store/store.js'
import { API_END_POINT } from '../../../../config/commonConfig'

export default {
  init () {
  },
  validateCallBack (fullPath) {
    const baseURL = `${API_END_POINT}${fullPath}`
    return axios.get(baseURL)
  }
}